export const blogAPI = {
  getWordPressPosts: async () => {
    try {
      const response = await fetch(
        "https://blog.araria.com.br/wp-json/wp/v2/posts?_embed"
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const posts = await response.json();
      return posts
        .sort(
          (a: any, b: any) =>
            new Date(b.date).getTime() - new Date(a.date).getTime()
        )
        .slice(0, 9)
        .map((post: any) => ({
          id: post.id,
          // remove html entities and tags from title
          title: post.title.rendered
            .replace(/&#\d+;/g, "") // remove HTML entities like &#8211;
            .replace(/&[^;]+;/g, "") // remove other HTML entities
            .replace(/<[^>]*>?/gm, ""), // remove HTML tags
          excerpt: post.excerpt.rendered,
          content: post.content.rendered,
          date: post.date,
          featuredImage: post._embedded?.["wp:featuredmedia"]?.[0]?.source_url,
          slug: post.slug,
          link: `https://blog.araria.com.br/${post.slug}`,
        }));
    } catch (error) {
      console.error("Error fetching WordPress posts:", error);
      throw error;
    }
  },
};
